/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { FunctionComponent } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { classes } from '@adobe-commerce/elsie/lib';
import '@adobe-commerce/elsie/components/Divider/Divider.css';

export interface DividerProps extends HTMLAttributes<HTMLHRElement> {
  variant?: 'primary' | 'secondary';
}

export const Divider: FunctionComponent<DividerProps> = ({
  variant = 'primary',
  className,
}) => {
  return (
    <hr
      role="separator"
      className={classes([
        'dropin-divider',
        `dropin-divider--${variant}`,
        className,
      ])}
    />
  );
};
